import type { MatchEvent } from "@marshmallow-duel/simulation";

export class GameAudio {
  readonly #cache = new Map<string, HTMLAudioElement>();
  #enabled: boolean;
  #screaming: boolean;
  #music: HTMLAudioElement | null = null;

  constructor(enabled = true, screaming = true) {
    this.#enabled = enabled;
    this.#screaming = screaming;
  }

  setEnabled(enabled: boolean): void {
    this.#enabled = enabled;
  }

  setScreaming(enabled: boolean): void {
    this.#screaming = enabled;
  }

  playEvents(events: readonly MatchEvent[]): void {
    if (!this.#enabled) return;
    for (const event of events) if (event.sound && (this.#screaming || event.type !== "death")) this.play(event.sound);
  }

  play(name: string): void {
    let audio = this.#cache.get(name);
    if (!audio) {
      audio = new Audio(`/assets/original/sounds/${name}.wav`);
      audio.preload = "auto";
      this.#cache.set(name, audio);
    }
    const instance = audio.cloneNode(true) as HTMLAudioElement;
    instance.volume = 0.7;
    void instance.play().catch(() => undefined);
  }

  startMusic(track: number | "menu"): void {
    this.stopMusic();
    const audio = new Audio(`/assets/original/music/${track}.mp3`);
    audio.loop = true;
    audio.volume = 0.42;
    this.#music = audio;
    void audio.play().catch(() => undefined);
  }

  stopMusic(): void {
    if (!this.#music) return;
    this.#music.pause();
    this.#music.currentTime = 0;
    this.#music = null;
  }
}
